import {createApp} from 'vue'
import EditProfileForm from './EditProfileForm'

const el = '.kb-component--edit-profile-form'

export default function(Store){
    const DOM = document.querySelectorAll(el)
    if(DOM.length){
        DOM.forEach((EditProfileFormDOM)=>{

            const props = {
                pageId: EditProfileFormDOM.dataset.pageId,
                userProfileId: EditProfileFormDOM.dataset.userProfileId,
                userData: JSON.parse(EditProfileFormDOM.dataset.userData),
                deleteProfileUrl: EditProfileFormDOM.dataset.deleteProfileUrl,
                isNewUser: EditProfileFormDOM.dataset.isNewUser === "true",
                privacyPolicyHtml: EditProfileFormDOM.dataset.privacyPolicyHtml,
                continueUrl: EditProfileFormDOM.dataset.continueUrl,
            }

            const component = createApp(EditProfileForm, props).use(Store)
            component.mount(EditProfileFormDOM)
        })
    }
}